import { createApi } from '@reduxjs/toolkit/query/react';

import { API_BASE_URL } from '@/config';
import { nonAbortingSignalBaseQuery } from '@/store/services/baseQuery';

const authApi = createApi({
    baseQuery: nonAbortingSignalBaseQuery,
    endpoints: (builder) => ({
        getMe: builder.query({
            query: () => `${API_BASE_URL}/auth/me`,
        }),
    }),
    reducerPath: 'authApi',
});

export const { useGetMeQuery } = authApi;
export default authApi;
